import * as moment from 'moment';
import * as _ from 'lodash';
import { Button, Col, Label, OverlayTrigger, Panel, Row, Tooltip, Well } from 'react-bootstrap';
import { ReImburseTableWrapper } from '../styles';
import { WageAndTravelReimbursementRequestStatus } from '@nkr/enums/index';
import { IWatrRequest, IWatrRequestTravels } from '@nkr/models/index';
import Header from './header';
import { getMileageRateForDate } from './year-rates';

interface IProps {
    data: IWatrRequest,
    travels: IWatrRequestTravels[]
}

const ClaimHistory = (props: IProps) => {
    const renderTooltip = (text) => (
        <Tooltip id="tooltip">{text}</Tooltip>
    );

    const travels = (props.data.requestTravels || []).filter(x =>
        x.status != WageAndTravelReimbursementRequestStatus.PendingApproval ||
        (x.status == WageAndTravelReimbursementRequestStatus.PendingApproval && (x.declines?.length || 0) > 0)
    );

    const filterAddress = (address: string) => {
        return address.split(/[,#]/)[0];               
    };

    const sortedTravelList = _.orderBy(travels, x => x.lastUpdated, ['desc']);

    return (
        <>
            {sortedTravelList.length == 0 ? "No entries recorded." :
                sortedTravelList.map((x, trvindex, arr) => {
                    let totalTripMiles = 0;
                    let totalTripReimburse = 0;
                    let roundTripInstances = x.roundTripInstances;
                    let oneWayMiles = 0;
                    let totaloneWayMiles = 0;
                    let roundTripMiles = 0;
                    let numberOfTrips = 0;
                    let reimbursementRate = getMileageRateForDate(x.createdDateTime);

                    totalTripMiles = x.roundTripMiles ?? 0;
                    numberOfTrips = x.roundTripInstances.length;
                    oneWayMiles = numberOfTrips > 0 ? totalTripMiles / numberOfTrips / 2 : 0;
                    totaloneWayMiles = oneWayMiles * numberOfTrips;
                    roundTripMiles = numberOfTrips > 0 ? totalTripMiles / numberOfTrips : 0;

                    if (x.roundTripInstances.length > 0) {
                        let orderedByReimbursements = _.orderBy(
                            x.roundTripInstances,
                            (trip) => moment(trip.tripDate),
                            ['desc']
                        );

                        reimbursementRate = orderedByReimbursements[0].reimbursementRate;
                    }

                    let reimbursementAmount = Math.ceil(roundTripMiles * reimbursementRate);
                    let totalReimbursementAmount = Math.ceil(totalTripMiles * reimbursementRate);
                    let totalMilesReimbursementAmountWithOverride = 0;
                    let overrideMiles = x.overrideMiles ?? 0;
                    let isMilesOverWritten = x.isMilesOverWritten;

                    if (isMilesOverWritten) {
                        totalMilesReimbursementAmountWithOverride = overrideMiles * reimbursementRate;
                    } else {
                        totalMilesReimbursementAmountWithOverride = totalTripMiles * reimbursementRate;
                    }

                    let totalMealsReimbursementAmountWithOverride = 0
                    let overrideMeals = x.overrideMeals ?? 0;
                    let mealExpense = x.mealExpense ?? 0;
                    let isMealsOverWritten = x.isMealsOverWritten;

                    if (isMealsOverWritten) {
                        totalMealsReimbursementAmountWithOverride = overrideMeals;
                    } else {
                        totalMealsReimbursementAmountWithOverride = mealExpense;
                    }

                    let requestedGrandTotal = x.hotelLodgingExpense + x.flightAndTrainExpense + totalReimbursementAmount + x.carServiceExpense + x.mealExpense + x.dependentCareExpense;
                    let approvedGrandTotal = x.hotelLodgingExpense + x.flightAndTrainExpense + totalMilesReimbursementAmountWithOverride + x.carServiceExpense + totalMealsReimbursementAmountWithOverride + x.dependentCareExpense;

                    if (roundTripInstances.length > 0) {
                        let orderedByReimbursements = _.orderBy(roundTripInstances, x => moment(x.tripDate), ['desc']);
                        const firstTrip = orderedByReimbursements[0];
                        reimbursementRate = firstTrip.reimbursementRate ?? getMileageRateForDate(firstTrip.tripDate ? new Date(firstTrip.tripDate as any) : x.createdDateTime);
                    } else {
                        reimbursementRate = getMileageRateForDate(x.createdDateTime);
                    }

                    return (
                        <>
                            {trvindex > 0 &&
                                <div style={{ marginTop: 20, marginBottom: 20, height: 5, background: 'repeating-linear-gradient(45deg, #ddd, #ddd 10px, #ccc 10px, #ccc 20px)' }}></div>
                            }

                            <div className='well' style={{ padding: 9, marginBottom: 0 }}>
                                <Header data={props.data} travel={x} showStatus={true} />

                                {(x.declines ? x.declines.length > 0 : false) &&
                                    <ReImburseTableWrapper bordered striped condensed style={{ width: '100%' }}>
                                        <colgroup>
                                            <col style={{ width: '5%' }} />
                                            <col style={{ width: '15%' }} />
                                            <col style={{ width: '25%' }} />
                                            <col style={{ width: '40%' }} />
                                        </colgroup>

                                        <thead>
                                            <tr style={{ backgroundColor: '#dc3546', color: 'white', textAlign: 'center' }}>
                                                <th colSpan={6}>Decline Log History</th>
                                            </tr>
                                        </thead>

                                        <thead>
                                            <tr>
                                                <th>Rank</th>
                                                <th>Processor</th>
                                                <th>Log Date</th>
                                                <th>Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {x.declines.sort((a, b) => new Date(a.logDate).getTime() - new Date(b.logDate).getTime()).map((item, index) => {
                                                let truncatedReason = item.logMessage.length > 50 ? item.logMessage.substring(0, 50) + '...' : item.logMessage;

                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.userFirstName} {item.userLastName}</td>
                                                        <td>{moment(item.logDate).format('MM/DD/YYYY')}</td>
                                                        <td>
                                                            <OverlayTrigger
                                                                trigger='hover'
                                                                placement={'right'}
                                                                rootClose
                                                                overlay={renderTooltip(item.logMessage)}
                                                            >
                                                                <span style={{ cursor: 'pointer' }}>{truncatedReason}</span>
                                                            </OverlayTrigger>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </ReImburseTableWrapper>
                                }

                                {x.roundTripInstances.length > 0 &&
                                    <ReImburseTableWrapper bordered striped condensed style={{ width: '100%' }}>
                                        <colgroup>
                                            <col style={{ width: '5%' }} />
                                            <col style={{ width: '10%' }} />
                                            <col style={{ width: '15%' }} />
                                            <col style={{ width: '15%' }} />
                                            <col style={{ width: '15%' }} />
                                            <col style={{ width: '18%' }} />
                                        </colgroup>

                                        <thead>
                                            <tr style={{ backgroundColor: '#6c757d', color: 'white', textAlign: 'center' }}>
                                                <th colSpan={6}>Self-Driving Mileage Cap: {props.data.limit.mileage.toLocaleString('en-us')} Miles @ ${reimbursementRate.toFixed(2)}/mile</th>
                                            </tr>
                                        </thead>

                                        <thead>
                                            <tr>
                                                <th>Trips</th>
                                                <th>Date</th>
                                                <th>Reason</th>
                                                <th> <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <span>One-Way Miles</span>
                                                    <Button
                                                        href={
                                                            "https://www.google.com/maps/dir/?api=1&origin="
                                                            + encodeURI(filterAddress(props.data.addressLine1) + ", " + props.data.city + ", " + props.data.stateAbbr + ", " + props.data.postalCode)
                                                            + "&destination=" + props.data.centerLatitude
                                                            + "," + props.data.centerLongitude
                                                        }
                                                        target='_blank'
                                                        bsStyle='success'
                                                        bsSize='small'
                                                        style={{ flexShrink: 0, whiteSpace: 'nowrap', padding: '2px 5px', margin: 0 }}
                                                    >
                                                        Verify Miles
                                                    </Button>
                                                </div>
                                                </th>
                                                <th>Round Trip Miles</th>
                                                <th>Mileage Reimbursement</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {x.roundTripInstances.sort((a, b) => new Date(a.tripDate).getTime() - new Date(b.tripDate).getTime()).map((item, index) => {
                                                totalTripMiles += item.tripMiles;
                                                totalTripReimburse += item.reimbursementAmount;

                                                const truncatedReason = item.tripReason.length > 20 ? item.tripReason.substring(0, 20) + '...' : item.tripReason;

                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{moment(item.tripDate).format('MM/DD/YYYY')}</td>
                                                        <td>
                                                            <OverlayTrigger
                                                                trigger='hover'
                                                                placement={'right'}
                                                                rootClose
                                                                overlay={renderTooltip(item.tripReason)}
                                                            >
                                                                <span style={{ cursor: 'pointer' }}>{truncatedReason}</span>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td>{Math.ceil(oneWayMiles).toLocaleString('en-US')}</td>
                                                        <td>{Math.ceil(roundTripMiles).toLocaleString('en-US')}</td>
                                                        <td>${Math.ceil(reimbursementAmount).toLocaleString('en-US')}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan={3}>Total Miles Requested:</td>
                                                <td>{Math.ceil(totaloneWayMiles).toLocaleString('en-US')}</td>
                                                <td>{Math.ceil(x.roundTripMiles).toLocaleString('en-US')}</td>
                                                <td>
                                                    <strong>${Math.ceil(totalReimbursementAmount).toLocaleString('en-US')}</strong>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </ReImburseTableWrapper>
                                }

                                <ReImburseTableWrapper bordered striped condensed style={{ width: '100%' }}>
                                    <colgroup>
                                        <col style={{ width: '20%' }} />
                                        <col style={{ width: '20%' }} />
                                        <col style={{ width: '20%' }} />
                                        <col style={{ width: '20%' }} />
                                        <col style={{ width: '20%' }} />
                                    </colgroup>
                                    <thead>
                                        <tr style={{ backgroundColor: '#6c757d', color: 'white', textAlign: 'center' }}>
                                            <th colSpan={5}>Travel Expense Request Summary</th>
                                        </tr>
                                    </thead>
                                    <thead>
                                        <tr>
                                            <th>Expense Type</th>
                                            <th>Requested</th>
                                            <th>Reimbursement Limit</th>
                                            <th>Override</th>
                                            <th>Approved</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Self-Driving Mileage:</td>
                                            <td>
                                                ${Math.ceil(totalReimbursementAmount).toLocaleString('en-US')}
                                            </td>
                                            <td>{props.data.limit.mileage.toLocaleString('en-us')} miles</td>
                                            <td>{Math.ceil(x.reimbursableMiles).toLocaleString('en-US')}</td>
                                            <td>${Math.ceil(totalMilesReimbursementAmountWithOverride).toLocaleString('en-US')}</td>
                                        </tr>

                                        <tr>
                                            <td>Lodging:</td>
                                            <td>
                                                ${Math.ceil(x.hotelLodgingExpense).toLocaleString('en-US')}
                                            </td>
                                            <td>{props.data.limit.hotelNights.toLocaleString('en-us')} nights</td>
                                            <td>--</td>
                                            <td>${Math.ceil(x.hotelLodgingExpense).toLocaleString('en-US')}</td>
                                        </tr>
                                        <tr>
                                            <td>Flight(s):</td>
                                            <td>
                                                ${Math.ceil(x.flightAndTrainExpense).toLocaleString('en-US')}
                                            </td>
                                            <td>{props.data.limit.roundTrips.toLocaleString('en-us')} Round Trips</td>
                                            <td>--</td>
                                            <td>${Math.ceil(x.flightAndTrainExpense).toLocaleString('en-US')}</td>
                                        </tr>

                                        <tr>
                                            <td>Transportation Expenses:</td>
                                            <td>
                                                ${Math.ceil(x.carServiceExpense).toLocaleString('en-US')}
                                            </td>
                                            <td>${props.data.limit.transportationExpenses.toLocaleString('en-us')}</td>
                                            <td>--</td>
                                            <td>${Math.ceil(x.carServiceExpense).toLocaleString('en-US')}</td>
                                        </tr>

                                        <tr>
                                            <td>Meals:</td>
                                            <td>
                                                {x.mealExpense != null ? `$${Math.ceil(x.mealExpense).toLocaleString('en-US')}` : '--'}
                                            </td>
                                            <td>${props.data.limit.meals}</td>
                                            <td>{x.reimbursableMeals != null ? `$${Math.ceil(x.reimbursableMeals).toLocaleString('en-US')}` : '--'}</td>
                                            <td>${totalMealsReimbursementAmountWithOverride}</td>
                                        </tr>

                                        <tr>
                                            <td>Dependent Care:</td>
                                            <td>
                                                {x.dependentCareExpense != null ? `$${Math.ceil(x.dependentCareExpense).toLocaleString('en-US')}` : '--'}
                                            </td>
                                            <td>${props.data.limit.dependentCare.toLocaleString('en-us')}</td>
                                            <td>--</td>
                                            <td>{x.dependentCareExpense != null ? `$${Math.ceil(x.dependentCareExpense).toLocaleString('en-US')}` : '--'}</td>
                                        </tr>
                                    </tbody>

                                    <tfoot>
                                        <tr style={{ backgroundColor: '#fbead0' }}>
                                            <td>Total:</td>
                                            <td>${Math.ceil(requestedGrandTotal).toLocaleString('en-US')}</td>
                                            <td>${props.data.limit.derReimbursementLimit.toLocaleString('en-us')}</td>
                                            <td>--</td>
                                            <td>
                                                <strong>${Math.ceil(approvedGrandTotal).toLocaleString('en-US')}</strong>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </ReImburseTableWrapper>
                            </div>
                        </>
                    );
                })}
        </>
    );
}

export default ClaimHistory;